import * as d3 from "d3";
import { useEffect, useRef } from "react";

type WeeklyBarChartLayoutProps = {
  weekdayLabels: string[];
  x: d3.ScaleBand<number>;
  y: d3.ScaleLinear<number, number>;
  mainInnerHeight: number;
};

export function WeeklyBarChartLayout({ weekdayLabels, x, y, mainInnerHeight }: WeeklyBarChartLayoutProps) {
  const layerRef = useRef<SVGGElement>(null);

  useEffect(() => {
    if (!layerRef.current) return;
    const selection = d3.select(layerRef.current);

    // Y軸
    const yAxis = d3.axisLeft(y).tickValues(d3.range(0, 25, 3));
    const axisG = selection.selectAll<SVGGElement, unknown>("g.y-axis").data([null]);
    axisG.enter().append("g").attr("class", "y-axis").merge(axisG).call(yAxis);

    // 曜日ラベル
    const barWidth = x.bandwidth();
    const labels = selection.selectAll<SVGTextElement, string>("text.weekday-label").data(weekdayLabels);

    labels.join(
      (enter) =>
        enter
          .append("text")
          .attr("class", "weekday-label")
          .attr("text-anchor", "middle")
          .attr("y", mainInnerHeight + 20)
          .attr("x", (_d, i) => (x(i) ?? 0) + barWidth / 2)
          .text((d) => d),
      (update) =>
        update
          .attr("y", mainInnerHeight + 20)
          .attr("x", (_d, i) => (x(i) ?? 0) + barWidth / 2)
          .text((d) => d),
      (exit) => exit.remove(),
    );
  }, [weekdayLabels, x, y, mainInnerHeight]);

  return (
    <g
      ref={layerRef}
      className="layout-layer"
    />
  );
}
